import Vue from 'vue'
import './plugins/axios'
import './mixins'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import mask from './plugins/vue-the-mask'
import store from './store'
import router from './router'

Vue.config.productionTip = false

new Vue({
	vuetify,
	mask,
	router,
	store,
	render: h => h(App)
}).$mount('#app')
